import axios from "axios";

const API_BASE = "/api/message-templates";

export const messageTemplateService = {
  // Get all templates for a tool type
  async getTemplates(toolType) {
    try {
      const response = await axios.get(`${API_BASE}?tool_type=${toolType}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching templates:", error);
      throw error;
    }
  },

  // Create a new template
  async createTemplate(templateData) {
    try {
      const response = await axios.post(API_BASE, templateData);
      return response.data.data;
    } catch (error) {
      console.error("Error creating template:", error);
      throw error;
    }
  },

  // Update an existing template
  async updateTemplate(id, templateData) {
    try {
      const response = await axios.patch(`${API_BASE}/${id}`, templateData);
      return response.data;
    } catch (error) {
      console.error("Error updating template:", error);
      throw error;
    }
  },

  // Delete a template
  async deleteTemplate(id) {
    try {
      const response = await axios.delete(`${API_BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting template:", error);
      throw error;
    }
  },

  // Get a single template by ID
  async getTemplate(id) {
    try {
      const response = await axios.get(`${API_BASE}/${id}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching template:", error);
      throw error;
    }
  },
}; 